import {
  ScanLine, LayoutDashboard, ShoppingCart, Package, Tags, Users as UsersIcon,
  Receipt, Store, ShoppingBag, Printer, FileBarChart, HandCoins, Boxes, Clock, DatabaseBackup, CreditCard, Server, Palette, ScrollText,
  ArrowDownToLine, ArrowUpFromLine, ClipboardCheck, Activity, BellRing, ShieldCheck,
} from "lucide-react";

export const NAV = [
  {section: "Pengaturan", items: [{ to: "/appearance", label: "Tampilan / Tema", icon: Palette, roles: ["admin"] }]},
  {
    section: "Administrasi Master",
    items: [
      { to: "/master/platform", label: "Platform", icon: CreditCard, roles: ["admin"], masterOnly: true },
      { to: "/master/tenants", label: "Kelola Tenant", icon: Store, roles: ["admin"], masterOnly: true },
      { to: "/master/system", label: "Status VPS", icon: Server, roles: ["admin"], masterOnly: true },
      { to: "/master/backup", label: "Backup NAS & Jadwal", icon: DatabaseBackup, roles: ["admin"], masterOnly: true },
    ],
  },
  {
    section: null,
    items: [
      { to: "/pos", label: "Kasir", icon: ShoppingCart, roles: ["admin", "cashier"] },
      { to: "/transactions", label: "Transaksi", icon: Receipt, roles: ["admin", "cashier"] },
      { to: "/piutang", label: "Piutang", icon: HandCoins, roles: ["admin", "cashier"] },
    ],
  },
  {
    section: "Backoffice",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin"] },
      { to: "/promotions", label: "Promo Otomatis", icon: Tags, roles: ["admin"] },
      { to: "/reports", label: "Laporan", icon: FileBarChart, roles: ["admin"] },
      { to: "/shifts", label: "Riwayat Shift", icon: Clock, roles: ["admin"] },
      { to: "/warehouse", label: "Penerimaan Gudang", icon: ScanLine, roles: ["admin", "warehouse"] },
      { to: "/whatsapp", label: "WhatsApp Toko", icon: ScanLine, roles: ["admin"], tenantOnly: true },
      { to: "/purchases", label: "Pembelian", icon: ShoppingBag, roles: ["admin"] },
      {
        label: "Produk & Inventori", icon: Package, roles: ["admin", "cashier", "warehouse"], children: [
          { to: "/products", label: "Produk", icon: Package, roles: ["admin", "warehouse"] },
          {
            label: "Inventori", icon: Boxes, roles: ["admin", "cashier", "warehouse"], children: [
              { to: "/stok?tab=stok", label: "Stok Saat Ini", icon: Boxes, roles: ["admin"] },
              { to: "/stok?tab=masuk", label: "Stok Masuk", icon: ArrowDownToLine, roles: ["admin"] },
              { to: "/stok?tab=keluar", label: "Stok Keluar", icon: ArrowUpFromLine, roles: ["admin"] },
              { to: "/stok?tab=opname", label: "Stok Opname", icon: ClipboardCheck, roles: ["admin"] },
              { to: "/stok?tab=pergerakan", label: "Pergerakan Stok", icon: Activity, roles: ["admin"] },
              { to: "/branch-stock", label: "Stok Semua Cabang", icon: Boxes, roles: ["admin"] },
              { to: "/stock-requests", label: "Permintaan & Transfer", icon: Package, roles: ["admin", "cashier", "warehouse"] },
              { to: "/stock-alerts", label: "Peringatan Stok", icon: BellRing, roles: ["admin"], tenantOnly: true },
            ],
          },
        ],
      },
      { to: "/suppliers", label: "Supplier", icon: ShoppingBag, roles: ["admin"] },
      { to: "/categories", label: "Kategori", icon: Tags, roles: ["admin"] },
      { to: "/users", label: "Pengguna", icon: UsersIcon, roles: ["admin"] },
      { to: "/supervisor", label: "Persetujuan Supervisor", icon: ShieldCheck, roles: ["admin"] },
      { to: "/stores", label: "Profil Toko", icon: Store, roles: ["admin"] },
      { to: "/backup", label: "Backup & Restore", icon: DatabaseBackup, roles: ["admin"] },
      { to: "/settings", label: "Printer", icon: Printer, roles: ["admin"] },
      { to: "/audit-logs", label: "Log Aktivitas", icon: ScrollText, roles: ["admin"] },
      { to: "/payment-methods", label: "Metode Pembayaran", icon: CreditCard, roles: ["admin"] },
    ],
  },
];

export const ROLE_LABELS = { admin: "Administrator", warehouse: "Gudang", cashier: "Kasir" };
export function navigationFor(role, tenantKind) {
 const allowed = item => item.roles.includes(role) && (!item.masterOnly || tenantKind === "master") && (!item.tenantOnly || tenantKind === "tenant");
 const filterItem = item => {
   if (!allowed(item)) return null;
   if (!item.children) return item;
   const children = item.children.map(filterItem).filter(Boolean);
   return children.length ? { ...item, children } : null;
 };
 return NAV.map(group => ({ ...group, items: group.items.map(filterItem).filter(Boolean) })).filter(group => group.items.length);
}
